<div class="container" style="height: 100%; display: flex;">
    <div style="width: 30%; height: 100%; border:solid; border-color: rgb(44, 44, 44); background: rgb(221, 221, 221);"></div>
    <div style="width: 70%; height: 100%; border:solid; border-color: rgb(44, 44, 44); background: rgb(221, 221, 221);"></div>
</div>
